
import classes from "./ButtonSend.module.scss"
import { IconButton } from "@educaplay/core/components";
import { SendIcon } from "../Icons";
import { Button, COLORS, useGameSounds, useMediaQuery, useTranslate } from "@educaplay/core";
import { TEST_SOUNDS } from "../../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { sendExam } from "@educaplay/store/slices/gameSlice";
import { Dialog } from "@educaplay/core/components";
import clsx from "clsx";
import { isUnansweredAnswer } from "@educaplay/store/utils/functions";





export default function ButtonSend(props) {

    const { className, type="submit" , passFinalQuestion, handleHover} = props;

    const gameSound = useGameSounds();
    const questions = useSelector(state => state.game.questions);
    const dispatch = useDispatch(); 
    const isMobileTablet= (useMediaQuery("(min-width: 1280px)"));
    const t = useTranslate();
    const [hasAnswered, setHasAnswered] = useState(false);


    const areUnansweredQuestions = (questions) => {
        return questions.some(question => isUnansweredAnswer(question.answer))
    }

    const numUnansweredQuestions = questions.length - questions.filter(question => !isUnansweredAnswer(question.answer)).length;


    const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);

    const sendExamFunction = () => {
        setHasAnswered(true);
        dispatch(sendExam());
        closeDialog();
    }

    const sendExamHandler = () => {
        if(hasAnswered) return;
        gameSound.play(TEST_SOUNDS.SUBMIT);
        if (areUnansweredQuestions(questions)) {
            gameSound.play(TEST_SOUNDS.MOVE);
            setOpenConfirmationDialog(true);
        } else {
            sendExamFunction();
        }
    }

    const closeDialog = () => {
        setOpenConfirmationDialog(false);
    }

    return (
        <>
            <Dialog open={openConfirmationDialog} onClose={closeDialog} variant="explanation" animated>
                <div className={classes.feedbackContainer}>
                    <div className={classes.feedbackHeader}>{t('specific.questionsLeft',{unanswereds: numUnansweredQuestions})}</div>
                    <div className={classes.feedbackMsgContainer}>
                        <div className={classes.feedbackMsg}>
                            {t('specific.finishTest')}
                        </div>
                        <div className={classes.buttonsFeedbackContainer}>
                            <Button onClick={closeDialog} className={classes.btnCancel} >{t('common.settings.cancel')}</Button>
                            <Button onClick={sendExamFunction} className={classes.btnAccept}>{t('common.settings.accept')}</Button>
                        </div>
                    </div>
                </div>

            </Dialog>
            {!isMobileTablet && (
                <div className={clsx(classes.buttonContainer, className)}>
                    <IconButton
                        type={type}
                        icon={<SendIcon color={COLORS.primary}/>}
                        className={classes.sendButton}
                        onClick={sendExamHandler}
                        disabled={!passFinalQuestion}
                        onMouseEnter={handleHover} />
                </div>)}

            {isMobileTablet && (
                <div>
                    <Button type={"button"}
                        icon={<SendIcon color={COLORS.primary}/>}
                        className={classes.sendButtonDesktop}
                        disabled={!passFinalQuestion}
                        onClick={sendExamHandler}
                        onMouseEnter={handleHover}
                    >
                        {t('specific.send')}
                    </Button>

                </div>)}


        </>
    );
}